import { render, staticRenderFns } from "./ChartFrequentIssues.vue?vue&type=template&id=219414c6&scoped=true&"
import script from "./ChartFrequentIssues.vue?vue&type=script&lang=js&"
export * from "./ChartFrequentIssues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219414c6",
  null
  
)

export default component.exports